{
  "srTitle": "Проєкт Anti Human Safari — захист цивільних від дронів у Херсоні, Україна",
  "logoAlt": "Логотип проєкту Anti Human Safari",
  "intro": "Ми надаємо захисне спорядження від атак малих дронів волонтерам, екстреним службам та працівникам критичної інфраструктури у Херсоні, Україна.",
  "safari": "З літа 2024 року цивільних у Херсоні систематично полюють російські військові за допомогою відеодронів — у терористичній кампанії, відомій як «Human Safari» («Полювання на людей»).",
  "unLink": "Комісія ООН визнала «Human Safari» воєнним злочином",
  "donateNow": "Підтримати зараз",
  "donateMonthly": "Щомісячний внесок",
  "otherWays": "інші способи допомогти",
  "instagram": "Instagram",
  "pastFundraisers": "Минулі збори:",
  "fundraiser2025": "Збір 2025",
  "donateVia": "Підтримати через:",
  "charityRef": "через благодійність у Великій Британії, з приміткою:",
  "germanCharityRef": "через благодійність у Німеччині, з приміткою:",
  "copy": "Копіювати",
  "copied": "Скопійовано!",
  "close": "Закрити",
  "viewMedia": "Переглянути медіа",
  "andrushenkoCredit": "Олександр Андрющенко, фотокореспондент медіа «Вгору»",
  "fruitSellerDescription": "Продавця фруктів переслідує дрон на оптоволокні",
  "khersonPoliceCredit": "від @khersonpolice",
  "firefighterDescription": "Рятувальник гасить автомобіль після удару «Human Safari», позаду лежить постраждалий",
  "previousMedia": "Попереднє",
  "nextMedia": "Наступне",
  "fpvDroneDescription": "FPV-дрон на полюванні «Human Safari»",
  "busAttackDescription": "Одна з багатьох атак FPV-дронів на громадський транспорт",
  "notFoundTitle": "Сторінку не знайдено",
  "notFoundMessage": "Такої сторінки не існує. Можливо, її перенесли або посилання хибне.",
  "backHome": "На головну",
  "droneDetectorDescription": "Детектори дронів — це невеликі портативні пристрої, які попереджають, коли поруч дрон",
  "vestDescription": "Легкі захисні жилети можуть зменшити тяжкість поранень від атаки дрона"
}
